import React, { useEffect, useState } from "react";
import { Spinner } from "@cinesys/ui/components";

/** How long a spinner has to stay warranted before it's shown. Short enough that a genuinely
 *  slow load still feels immediate, long enough that the common case — the `customer-context`
 *  call resolving near-instantly off a warm cache/local dev — never flashes a spinner that's
 *  gone again before anyone can register it. */
const PENDING_SPINNER_DELAY_MS = 150;

export interface DelayedSpinnerProps {
  padTop?: boolean;
}

/**
 * `useInterfaceAccess`'s "pending" spinner, for both Spotter and AB Vault (Addison: unify these,
 * they used to differ — one showed nothing, the other showed a `Spinner` immediately). Mounted
 * only while `access.status === "pending"`, so mounting IS "pending started" and unmounting
 * (status leaving "pending") IS "pending ended" — a plain mount-delay is enough to avoid a flash
 * for a fast resolve, no `active` prop or cleanup-on-status-change wiring needed from callers.
 */
const DelayedSpinner = ({ padTop }: DelayedSpinnerProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), PENDING_SPINNER_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return show ? <Spinner padTop={padTop} /> : null;
};

export default DelayedSpinner;
